<template>
  <div class="faq-page">
    <!-- Hero Section -->
    <div class="faq-hero">
      <div class="faq-hero-content">
        <h2 class="faq-hero-title">{{ $t('general.frequently_asked_questions') }}</h2>
        <div class="faq-search">
          <i class="uil-search faq-search-icon"></i>
          <input v-model="filter.search"
                 :placeholder="$t('faq.subject_search')"
                 class="faq-search-input"
                 type="text"
          />
        </div>
      </div>
    </div>

    <!-- FAQ Content -->
    <div class="faq-content">
      <template v-if="formattedItem && formattedItem.length > 0">
        <div v-for="category in formattedItem" :key="category.id" class="faq-category">
          <div class="faq-category-header">
            <i class="uil-folder-open faq-category-icon"></i>
            <h4 class="faq-category-title">{{ category.title }}</h4>
          </div>
          <div class="faq-card">
            <ul class="uk-accordion faq-accordion" uk-accordion>
              <template v-for="faq in category.faqs">
                <li v-if="faq?.description?.description" :key="faq.id" class="faq-item">
                  <a class="uk-accordion-title faq-question" href="#">
                    <i class="uil-comment-question faq-question-icon"></i>
                    <span>{{ faq.description.title }}</span>
                  </a>
                  <div class="uk-accordion-content faq-answer">
                    <div v-html="faq.description.description"></div>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </template>

      <!-- Empty State -->
      <div v-else-if="!assignment_loading" class="faq-empty">
        <i class="uil-comment-slash faq-empty-icon"></i>
        <p>{{ $t('general.no_records_found') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";

import module, {
  BASE_URL,
  MODULE_NAME,
  ERROR,
  ITEMS,
  GET_LIST,
  LOADING
} from "@/core/services/store/faq.module";

export default {
  name: "FAQ",
  data() {
    return {
      filter: {
        search: null,
      },
    }
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(MODULE_NAME, module);
  },
  computed: {
    items: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEMS];
      },
      set(value) {
      },
    },
    assignment_loading: {
      get() {
        return store.getters[MODULE_NAME + "/" + LOADING];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    formattedItem() {
      let results = [];
      if (this.items.length > 0) {
        this.items?.forEach((currentItem) => {
          results.push({
            id: currentItem.id,
            title: currentItem.description.title,
            faqs: currentItem.faqs
          });
        });
      }
      return results;
    },
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
  },
  methods: {
    getFaqResult() {
      let self = this;
      this.$store.dispatch(MODULE_NAME + "/" + GET_LIST, {
        url: BASE_URL,
        filters: {
          search: self.filter.search,
        },
      })
    },
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.getFaqResult, 500);
  },
  mounted() {
    this.getFaqResult();
  },
}
</script>

<style scoped>
/* ===== Hero Section ===== */
.faq-hero {
  background: #f5f4ff;
  border-radius: 16px;
  padding: 40px 24px;
  margin-bottom: 32px;
  text-align: center;
}

.faq-hero-content {
  max-width: 480px;
  margin: 0 auto;
}

.faq-hero-title {
  color: #4d4d4d;
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0 0 20px;
}

/* ===== Search ===== */
.faq-search {
  position: relative;
}

.faq-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #9ca3af;
}

.faq-search-input {
  width: 100%;
  height: 44px;
  padding: 0 14px 0 42px;
  border: 1px solid #e0dff5;
  border-radius: 10px;
  background: #fff;
  font-size: 14px;
  color: #4d4d4d;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  box-sizing: border-box;
}

.faq-search-input:focus {
  border-color: #7971ff;
  box-shadow: 0 2px 12px rgba(121, 113, 255, 0.15);
}

.faq-search-input::placeholder {
  color: #b0b0b0;
}

/* ===== FAQ Content ===== */
.faq-content {
  max-width: 720px;
  margin: 0 auto;
  padding-bottom: 32px;
}

/* ===== Category ===== */
.faq-category {
  margin-bottom: 28px;
}

.faq-category-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.faq-category-icon {
  font-size: 20px;
  color: #7971ff;
}

.faq-category-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #4d4d4d;
  margin: 0;
}

/* ===== Card ===== */
.faq-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* ===== Accordion ===== */
.faq-accordion {
  margin: 0;
  padding: 0;
  list-style: none;
}

.faq-item {
  border-bottom: 1px solid #f0f0f5;
}

.faq-item:last-child {
  border-bottom: none;
}

.faq-question {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #4d4d4d;
  text-decoration: none;
  transition: color 0.2s, background 0.2s;
}

.faq-question:hover {
  color: #7971ff;
  background: #fafaff;
}

.faq-question-icon {
  font-size: 20px;
  color: #ae71ff;
  flex-shrink: 0;
}

.uk-open .faq-question {
  color: #7971ff;
  background: #f5f4ff;
}

.uk-open .faq-question-icon {
  color: #7971ff;
}

/* ===== Answer ===== */
.faq-answer {
  padding: 0 20px 20px 52px;
  font-size: 0.9rem;
  line-height: 1.7;
  color: #5B657E;
  overflow-wrap: break-word;
  word-break: break-word;
}

.faq-answer :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.faq-answer :deep(table) {
  max-width: 100%;
  overflow-x: auto;
  display: block;
}

.faq-answer :deep(iframe) {
  max-width: 100%;
}

.faq-answer :deep(a) {
  color: #7971ff;
}

/* ===== Empty State ===== */
.faq-empty {
  text-align: center;
  padding: 60px 20px;
  color: #9ca3af;
}

.faq-empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
  display: block;
}

.faq-empty p {
  font-size: 1rem;
  margin: 0;
}

/* ===== Tablet ===== */
@media (max-width: 1024px) {
  .faq-content {
    max-width: 90%;
  }
}

/* ===== Offset Fix ===== */
@media (max-width: 1220px) {
  .faq-page {
    margin-top: -60px;
  }
}

/* ===== Mobil ===== */
@media (max-width: 640px) {
  .faq-page {
    margin-top: 0;
    padding: 16px 12px 0;
  }

  .faq-hero {
    padding: 28px 16px;
    border-radius: 12px;
    margin-bottom: 20px;
  }

  .faq-hero-title {
    font-size: 1.15rem;
    margin-bottom: 14px;
  }

  .faq-search-input {
    height: 40px;
    font-size: 13px;
    border-radius: 8px;
  }

  .faq-content {
    max-width: 100%;
    padding-bottom: 20px;
  }

  .faq-category {
    margin-bottom: 20px;
  }

  .faq-category-title {
    font-size: 0.95rem;
  }

  .faq-card {
    border-radius: 10px;
  }

  .faq-question {
    padding: 14px 16px;
    font-size: 0.9rem;
    gap: 10px;
  }

  .faq-question-icon {
    font-size: 18px;
  }

  .faq-answer {
    padding: 0 16px 16px 44px;
    font-size: 0.85rem;
    line-height: 1.6;
  }

  .faq-empty {
    padding: 40px 16px;
  }
}

/* ===== Kucuk Mobil ===== */
@media (max-width: 375px) {
  .faq-page {
    margin-top: 0;
    padding: 12px 8px 0;
  }

  .faq-hero {
    padding: 24px 12px;
    border-radius: 10px;
  }

  .faq-hero-title {
    font-size: 1rem;
  }

  .faq-search-input {
    height: 38px;
    font-size: 13px;
  }

  .faq-question {
    padding: 12px 12px;
    font-size: 0.85rem;
  }

  .faq-answer {
    padding: 0 12px 14px 40px;
    font-size: 0.8rem;
  }
}

/* Mobile accessibility and touch targets */
.faq-page {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

@media (max-width: 640px) {
  .faq-page {
    padding-left: 12px;
    padding-right: 12px;
  }

  .faq-hero {
    padding: 24px 16px;
    border-radius: 12px;
  }

  .faq-hero-title {
    font-size: 20px;
    line-height: 1.3;
  }

  .faq-search-input {
    height: 48px;
    min-height: 48px;
    padding: 12px 14px 12px 42px;
    font-size: 16px;
    border-radius: 10px;
  }

  .faq-category-header {
    gap: 8px;
    margin-bottom: 8px;
  }

  .faq-category-title {
    font-size: 18px;
    line-height: 1.4;
    overflow-wrap: anywhere;
  }

  .faq-question {
    min-height: 48px;
    box-sizing: border-box;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.4;
  }

  .faq-question-icon {
    font-size: 20px;
  }

  .faq-answer {
    padding: 0 16px 16px 52px;
    font-size: 14px;
    line-height: 1.6;
  }

  .faq-answer :deep(pre),
  .faq-answer :deep(code) {
    max-width: 100%;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
}

@media (max-width: 375px) {
  .faq-page {
    padding-left: 8px;
    padding-right: 8px;
  }

  .faq-question {
    padding-left: 12px;
    padding-right: 12px;
  }

  .faq-answer {
    padding-left: 44px;
    padding-right: 12px;
  }
}
</style>
